/**
 * opsTraceApi.js — Client for `/api/ops/scheduler-trace`.
 *
 * Wraps the admin-only ops sink that stores `/_trace?capture=N` JSON
 * snapshots on the server (TTL-bounded by `OPS_TRACE_RETENTION_DAYS`).
 * All calls return the normalized `{ ok, data | error, status }` shape
 * from httpClient — no PHI in any of these paths.
 */
import { get, post } from './httpClient';

const BASE = '/api/ops/scheduler-trace';

/** POST a sanitized capture payload to the sink. */
export const submitTraceSnapshot = (payload) => post(BASE, payload);

/** Recent snapshots summary (admin-only, capped). */
export const listTraceSnapshots = (limit = 20) => get(BASE, { limit });

/** Full payload for a single snapshot id. */
export const getTraceSnapshot = (snapshotId) => get(`${BASE}/${encodeURIComponent(snapshotId)}`);
